import { render, staticRenderFns } from "./df-page-account-cashback.vue?vue&type=template&id=35a5c8b2&"
import script from "./df-page-account-cashback.ts?vue&type=script&lang=js&"
export * from "./df-page-account-cashback.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports